import React from 'react';

const CardTopLeft = ({color}) => {
  return (
    <div className="cardTopLeft" style={{ backgroundColor: color }} ></div>
  );
};

export default CardTopLeft;
